import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  iconContainer: {
    marginBottom: theme.spacing(3),
  },
  icon: {
    fontSize: theme.spacing(5),
  },
}));

export default useStyles;
